/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useState } from "react";
import Pagination from "components/Pagination/Pagination";
import TableOrder from "components/Tables/TableOrder";
import environment from "constants/apiConst";
import ConfigurationCRUDContext from "context/ConfigurationCRUDContext";
import { __TypeTranport } from "request/configuration/__TypeTranport";
import { SectionContainerGene } from "styled/SectionContainer.styled";
import ConfigurationHeader from "../ConfigurationHeader";
import TbodyTypeTransp from "../tables/TbodyTypeTransp";
import { useLocation } from "react-router-dom";
import queryString from "query-string";
import { FormTypeTransport } from "../forms/FormTypeTransport";
import FormTypeTransportshow from "../FormShow/FormTypeTransportshow";
import { useSelector } from "react-redux";
import { useGlobalContext } from "context/GlobalContext";
import { useQuery } from "@tanstack/react-query";

const formEditSub = () => {
  return <FormTypeTransport />;
};

const formShow = () => {
  return <FormTypeTransportshow />;
};

export const TypesTrasport = () => {
  const [currentPage, setCurrentPage] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [maxPage, setMaxPage] = useState(1);
  const location = useLocation();
  const { q = "" } = queryString.parse(location.search);
  const freeZone_id = useSelector((state) => state.auth.dataUser.token); const {
    setRequestEdit,
    setRequestCreate,
    setRequestDelete,
    setFormEdit,
    setFormShow,
    update
  } = useContext(ConfigurationCRUDContext);

  const Title = [
    { name: "Transporte", order: "" },
    { name: "Descripción", order: "" },
    { name: "Estado", order: "" },
    { name: "Tipo contenedor", order: "" },
    { name: "Acciones", order: "" }
  ];

  useEffect(() => {
    setFormEdit(formEditSub);
    setFormShow(formShow);
    setRequestEdit(environment.TYPETRANSP_UPDATE);
    setRequestCreate(environment.TYPETRANSP_CREATE);
    setRequestDelete(environment.TYPETRANSP_DELETE);
  }, [q, update, page]);

  const { requestData } = useGlobalContext();

  const { data, isLoading, isError } = useQuery({
    queryKey: ["configTypeTranport", page, q, freeZone_id, update],
    queryFn: () => requestData({
      Endpoint: environment.TYPETRANSP_GET,
      pageParam: page,
      ...(q?.length !== 0 && { data: { search: q } }),
      PropertyBody: "sendJSONContentPOST",
    })
  })

  useEffect(() => {
    if (data?.data?.status?.code !== 200) return;
    if (data?.data?.status?.data?.last_page < page) setPage(1);
  }, [data?.data?.status?.data?.last_page])

  return (
    <>
      <SectionContainerGene>
        <ConfigurationHeader title="Tipo de transporte"></ConfigurationHeader>
        <TableOrder
          thead={Title}
          data={data?.data?.status?.code === 200 ? data?.data?.status?.data?.data : []}
          setData={setCurrentPage}
          loading={isLoading}
          tbodyData={TbodyTypeTransp}
        />
        <Pagination
          page={page}
          setPage={setPage}
          maxPage={data?.data?.status?.code === 200 ? data?.data?.status?.data?.last_page : 1}
          loading={isLoading}
        />
      </SectionContainerGene>
    </>
  );
};
